/* eslint-disable react/jsx-max-depth */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RegistrationModal = _interopRequireDefault(require("Modals/RegistrationModal"));
var _LoginModal = _interopRequireDefault(require("Modals/LoginModal"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _FacebookIcon = _interopRequireDefault(require("Icons/FacebookIcon"));
var _YoutubeIcon = _interopRequireDefault(require("Icons/YoutubeIcon"));
var _LinkedinIcon = _interopRequireDefault(require("Icons/LinkedinIcon"));
var _AccountIcon = _interopRequireDefault(require("Icons/AccountIcon"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class Header extends _react.Component {
  state = {
    login_modal: false,
    registration_modal: false,
    user_roles: [],
    open: false
  };
  ref_header = /*#__PURE__*/_react.default.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app?.state?.session?.user?.roles?.length > 0) {
      component.handleSessionChange({
        source: 'component'
      });
    }
    document.removeEventListener('scroll', component.staticNav);
    if (window.innerWidth > 767) {
      component.staticNav();
      document.addEventListener('scroll', component.staticNav);
    }
    component.setState({
      open: false
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      user_roles: app?.state?.session?.user?.roles || []
    });
  };
  openLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      login_modal_trigger: e.target,
      login_modal: true
    });
  };
  closeLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login_modal_trigger: undefined,
      login_modal: false
    });
  };
  openRegistrationModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      registration_modal_trigger: e.target,
      registration_modal: true
    });
  };
  closeRegistrationModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      registration_modal_trigger: undefined,
      registration_modal: false
    });
  };
  logout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/logout').then(function (xhr, response) {
      // Update user permissions now that user is disconnected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'logout'
      });
      app.navigateTo((0, _Routes.URL)('Home'));
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleLogin = () => {
    const component = this,
      props = this.props,
      state = this.state;

    // Update user permissions now that user is connected
    app.emit({
      event: 'sessionNeedsRefresh',
      source: 'loginModal'
    });
  };
  staticNav = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!component.ref_header.current) return;
    const scroll_top_height = document.scrollingElement ? document.scrollingElement.scrollTop : document.querySelector('html').scrollTop;
    const height_header = component.ref_header.current.getBoundingClientRect().height;
    if (height_header > scroll_top_height) {
      component.ref_header.current.classList.remove('o-front-header--fixed');
    } else {
      component.ref_header.current.classList.add('o-front-header--fixed');
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const roles = state.user_roles || [];
    const top_links = roles.includes('admin') || roles.includes('agent') || roles.includes('accompanist') ? component.getAdminLinks() : roles.includes('candidate') ? component.getCandidateLinks() : roles.includes('company') ? component.getCompanyLinks() : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action c-header-action--white"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "c-header-action__txt",
      onClick: component.openLoginModal
    }, /*#__PURE__*/_react.default.createElement(_AccountIcon.default, {
      color: "primary",
      fontSize: "large"
    }), ' ', "Se connecter")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action c-header-action--blue"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "c-header-action__txt",
      onClick: component.openRegistrationModal
    }, "S'inscrire")));
    const toggle_icon = state.open !== true ? /*#__PURE__*/_react.default.createElement("svg", {
      className: "o-front-header__toggle-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("line", {
      x1: "3",
      y1: "12",
      x2: "21",
      y2: "12"
    }), /*#__PURE__*/_react.default.createElement("line", {
      x1: "3",
      y1: "6",
      x2: "21",
      y2: "6"
    }), /*#__PURE__*/_react.default.createElement("line", {
      x1: "3",
      y1: "18",
      x2: "21",
      y2: "18"
    })) : /*#__PURE__*/_react.default.createElement("svg", {
      className: "o-front-header__toggle-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("line", {
      x1: "18",
      y1: "6",
      x2: "6",
      y2: "18"
    }), /*#__PURE__*/_react.default.createElement("line", {
      x1: "6",
      y1: "6",
      x2: "18",
      y2: "18"
    }));
    let output = /*#__PURE__*/_react.default.createElement("header", {
      className: 'o-front-header' + (state.open ? ' o-front-header--open' : ''),
      ref: component.ref_header
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/",
      className: "o-front-header__logo-link"
    }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
      className: "o-front-header__logo"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "o-front-header__toggle",
      onClick: e => component.setState({
        open: !state.open
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "o-front-header__toggle-label"
    }, "Menu"), toggle_icon), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-front-header__content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "o-front-header__top"
    }, top_links), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-front-header__bottom"
    }, /*#__PURE__*/_react.default.createElement("nav", {
      className: "o-front-header__navbar"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "c-front-navbar"
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: isActive("/") ? "c-front-navbar__link active" : "c-front-navbar__link",
      href: "/"
    }, "L'association")), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: isActive((0, _Routes.URL)('InfoCandidate')) ? "c-front-navbar__link active" : "c-front-navbar__link",
      href: (0, _Routes.URL)('InfoCandidate')
    }, "Candidats")), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: isActive((0, _Routes.URL)('InfoCompany')) ? "c-front-navbar__link active" : "c-front-navbar__link",
      href: (0, _Routes.URL)('InfoCompany')
    }, "Recruteurs")), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: isActive("/ressources") ? "c-front-navbar__link active" : "c-front-navbar__link",
      href: "/ressources"
    }, "Ressources")), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: isActive("/actualites") ? "c-front-navbar__link active" : "c-front-navbar__link",
      href: "/actualites"
    }, "Actualit\xE9s")), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-front-navbar__item__social-media"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.facebook.com/Aspiejob",
      className: "",
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_FacebookIcon.default, null)), /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.linkedin.com/company/aspiejob",
      className: "",
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_LinkedinIcon.default, null)), /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.youtube.com/channel/UCC_AlgZz1p5xa3DJ0CN95BA/featured",
      className: "",
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_YoutubeIcon.default, null))), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-front-navbar__with-us"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn--blue",
      href: (0, _Routes.URL)('Donate')
    }, "Faire un don"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn--blue",
      href: (0, _Routes.URL)('BecomeVolonteer')
    }, "Devenez b\xE9n\xE9vole")))))), /*#__PURE__*/_react.default.createElement(_RegistrationModal.default, {
      onClose: component.closeRegistrationModal,
      open: state.registration_modal,
      trigger_src: state.registration_modal_trigger
    }), /*#__PURE__*/_react.default.createElement(_LoginModal.default, {
      onClose: component.closeLoginModal,
      open: state.login_modal,
      trigger_src: state.login_modal_trigger,
      onLogin: component.handleLogin
    }));
    return output;
  }
  getCandidateLinks = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: (0, _Routes.URL)('CandidateAccount'),
      className: "c-header-action__txt"
    }, "Mon compte")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: (0, _Routes.URL)('CandidateCV'),
      className: "c-header-action__txt"
    }, "Mon CV en ligne")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/annonces",
      className: "c-header-action__txt"
    }, "Annonces")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/actualites",
      className: "c-header-action__txt"
    }, "Actualit\xE9s")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "c-header-action__txt",
      onClick: component.logout
    }, "D\xE9connexion")));
    return output;
  };
  getCompanyLinks = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const session_user = app.state?.session?.user;
    let my_acount_link = '/mon-compte-entreprise';
    let my_jobad_link = '/mes-annonces/' + session_user?.id;
    let output = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: my_acount_link,
      className: "c-header-action__txt"
    }, "Mon compte")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: my_jobad_link,
      className: "c-header-action__txt"
    }, "Mes annonces")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/candidats",
      className: "c-header-action__txt"
    }, "Candidats")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/actualites",
      className: "c-header-action__txt"
    }, "Actualit\xE9s")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "c-header-action__txt",
      onClick: component.logout
    }, "D\xE9connexion")));
    return output;
  };
  getAdminLinks = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-header-action"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/liste-des-candidats",
      className: "c-header-action__txt"
    }, "Administration"));
    return output;
  };
}
exports.default = Header;
function isActive(href) {
  if (href === '/') return document.location.pathname === '/';
  return document.location.pathname.startsWith(href);
}
